/**
 * Disconnect banner — shows when we had a welcome then lost the socket.
 * No auto-reconnect (the WP7 spec: server treats mid-match drop as a
 * forfeit; the user goes back to Home and starts fresh).
 */

import type { ReactElement } from "react";
import { useStore } from "../store/context.js";
import { navigate } from "../router/hashRoute.js";

export function DisconnectBanner(): ReactElement | null {
  const { state } = useStore();
  // Only show when we WERE welcomed and now the socket is closed.
  const c = state.connection;
  if (c.kind !== "closed") return null;
  // Suppress if a protocol mismatch owns the screen already.
  if (state.connection.kind !== "closed") return null;
  if (!c.cleanClose) {
    // Unclean drop — either we never got a welcome, or the socket errored.
    // Show the same UI; the wp7 spec doesn't distinguish visually.
  }
  return (
    <div
      data-testid="disconnect-banner"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        padding: "8px 16px",
        background: "#5a1a1a",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        zIndex: 50,
      }}
    >
      <span>Connection lost</span>
      <button
        type="button"
        data-testid="disconnect-back-home"
        onClick={() => {
          navigate({ kind: "home" });
        }}
        style={{
          padding: "4px 10px",
          background: "#fff",
          color: "#5a1a1a",
          border: "none",
          borderRadius: 4,
        }}
      >
        Back to home
      </button>
    </div>
  );
}
